module.exports = __webpack_public_path__ + "img/no-image.d14bf58f.png";